import React, { useState } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import Drawer from "@material-ui/core/Drawer";
import { useDispatch } from "react-redux";
import Table from "../../../ui/table";
import AddEditForm from "./add-edit-form";
import generateAction from "../../../../utils/action-helpers";
import { USER } from "../../../../state/actions";
import TooltipButton from "../../../ui/tooltip-button";
import Disclaimer from "../../../ui/disclaimer";
import removeIcon from "../../../../assets/img/shredder.svg";

const Records = ({ data, intl, extraToolbarOptions }) => {
  const { messages } = intl;
  const [openedDrawer, setOpenedDrawer] = useState(-1);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [openedModal, setOpenedModal] = useState(false);
  const dispatch = useDispatch();
  const successDelete = (index, payload) => {
    dispatch(generateAction(USER.DELETE, { index, users: payload }));
  };
  const columns = [
    {
      name: "id",
      label: "id"
    },
    {
      name: "role",
      label: "role",
      options: {
        filter: false
      }
    },
    {
      label: messages.empty,
      options: {
        sort: false,
        filter: false,
        cellRenderer: value => {
          const { index, original } = value.row;
          return (
            <div>
              <div className="manual-management-toolbar">
                <TooltipButton
                  type="button"
                  buttonClassName="btn-action"
                  iconClassName="icono-clear"
                  tooltipText="Eliminar usuario"
                  onClick={() => {
                    setSelectedIndex(index);
                    setOpenedModal(true);
                  }}
                />
                <TooltipButton
                  type="button"
                  buttonClassName="btn-action"
                  onClick={() => setOpenedDrawer(index)}
                  tooltipText="Editar usuario"
                  iconClassName="icono-write"
                />
              </div>
              <Drawer
                className="sidebar-container"
                open={openedDrawer === index}
                variant="persistent"
                anchor="right"
              >
                <AddEditForm
                  close={() => setOpenedDrawer(-1)}
                  isEditing
                  index={index}
                  editingObject={original}
                  users={data}
                />
              </Drawer>
              {openedDrawer === index && <div className="sidebar-back fade show" />}
            </div>
          );
        }
      }
    }
  ];
  const tableOption = {
    extraToolbarOptions,
    removeDownloadAction: true
  };
  return (
    <>
      <Disclaimer
        icon={<img src={removeIcon} alt="Eliminar usuario" />}
        title="Eliminar usuario"
        text="Perdeá la información de usuario que ha introducido. Esta acción no se puede deshacer."
        visible={openedModal}
        acepptButtonText="Eliminar"
        cancelButtonText="Cancelar"
        onCancel={() => {
          setOpenedModal(false);
          setSelectedIndex(-1);
        }}
        onAccept={() => {
          setOpenedModal(false);
          if (selectedIndex > -1) {
            successDelete(selectedIndex, data);
            setSelectedIndex(-1);
          }
        }}
      />
      <Table
        placeHolder="Buscar por id y rol..."
        className="users"
        columns={columns}
        data={data}
        options={tableOption}
      />
    </>
  );
};

Records.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.oneOf(["Admin", "Viewer", "Editor"])
    })
  ),
  extraToolbarOptions: PropTypes.node
};

Records.defaultProps = {
  data: [],
  extraToolbarOptions: undefined
};

export default injectIntl(Records);
